import {FormControl, Option} from 'platform/components';
import {Space} from 'platform/foundation';

import {UseFormReturn, useWatch} from 'react-hook-form';

import {isNil} from 'ramda';

import {i18n} from '@dms/i18n';
import {
  DepositSection,
  DocumentTemplateOptionGroup,
  SettingsFooter,
  SettingsSection,
} from '@dms/settings/shared';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {WarehouseDirectSaleVariantsDetailFormSchemaType} from '../../types/WarehouseDirectSaleVariantsDetailFormSchema';
import {getDepositFormBinding} from '../../utils/getDepositFormBinding';

interface DepositTabProps extends RequiredTestIdProps {
  control: FormControl<WarehouseDirectSaleVariantsDetailFormSchemaType>;
  formApi: UseFormReturn<WarehouseDirectSaleVariantsDetailFormSchemaType>;
  onDiscard: VoidFunction;
  directSaleVariantId: string | Nullish;
  docSeriesOptions: Option[];
  invoiceTemplateOptions: DocumentTemplateOptionGroup[];
  isTemplatesLoading?: boolean;
}

export function DepositTab(props: DepositTabProps) {
  const deposit = useWatch({control: props.control, name: 'deposit'});

  return (
    <>
      <SettingsSection>
        <DepositSection
          control={props.control}
          binding={getDepositFormBinding(props.formApi)}
          deposit={deposit}
          docSeriesOptions={props.docSeriesOptions}
          invoiceTemplateOptions={props.invoiceTemplateOptions}
          isTemplatesLoading={props.isTemplatesLoading}
          data-testid={props['data-testid']}
        />
      </SettingsSection>

      <Space vertical={18} />

      <SettingsFooter
        actions={[
          {
            type: 'button',
            variant: 'secondary',
            title: isNil(props.directSaleVariantId)
              ? i18n.t('general.actions.discard')
              : i18n.t('general.actions.discardChanges'),
            onClick: props.onDiscard,
            'data-testid': suffixTestId('discard', props),
          },
          {
            type: 'form-button',
            control: props.control,
            buttonType: 'submit',
            variant: 'primary',
            title: isNil(props.directSaleVariantId)
              ? i18n.t('general.actions.save')
              : i18n.t('general.actions.saveChanges'),
            'data-testid': suffixTestId('submit', props),
          },
        ]}
      />
    </>
  );
}
